import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import { Info20Px } from "@qubit/autoparts";
import { ReactNode } from "react";

type Props = {
  label: ReactNode;
  tooltip: string;
  infoAriaLabel?: string;
};

export function LabelWithInfoTooltip({ label, tooltip, infoAriaLabel }: Props) {
  const theme = useTheme();

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "flex-start",
        gap: 0.5,
        maxWidth: "100%",
        verticalAlign: "top"
      }}
    >
      <Box component="span" sx={{ flex: "1 1 auto", minWidth: 0 }}>
        {label}
      </Box>
      <Tooltip title={tooltip}>
        <IconButton
          aria-label={infoAriaLabel ?? tooltip}
          size="small"
          sx={{
            flexShrink: 0,
            alignSelf: "flex-start",
            p: 0.25,
            mt: "-1px"
          }}
        >
          <Info20Px fill={theme.palette.text.secondary} aria-hidden />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
